<template>
    <div class="px-4 pt-14 pb-4 thank-you-page">
        <!-- Confetti pieces -->
        <div v-for="n in confettiCount" :key="n" class="confetti" :style="getConfettiStyle(n)"></div>

        <div
            class="mb-4 p-4 flex items-center bg-gradient-to-br from-primary/5 to-purple-100 dark:from-neutral-700/50 dark:to-neutral-800/50 rounded-lg border border-gray-200 dark:border-neutral-700 shadow-sm gap-4 flex-col sm:flex-row md:flex-col lg:flex-row">

            <div class="flex gap-4 items-center">
                <!-- Icon -->
                <div class="flex items-center justify-center w-12 h-12 bg-primary_opc_less rounded-full flex-shrink-0">
                    <div class="w-6 h-6 text-primary">
                        <svg-vue icon="thumb-up" class="w-6 h-6 text-primary"></svg-vue>
                    </div>
                </div>

                <!-- Content -->
                <div class="flex-1">
                    <h3 class="text-lg font-semibold text-gray-800 dark:text-white">
                        {{ $t('Thank you for your purchase') }}!
                    </h3>
                    <p class="text-sm text-gray-600 dark:text-neutral-300 mt-1">
                        {{ $t('Your payment was successfully processed')}}.
                        {{$t('You can now view your updated status in your dashboard') }}.
                    </p>
                </div>
            </div>

            <!-- CTA -->
            <div class="shrink-0">
                
                <router-link :to="{ name: 'dashboard' }"
                    class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-gradient shadow-xl rounded-xl shadow hover:bg-primary/90 transition">
                    {{ $t('Go to Dashboard') }}
                </router-link>
            </div>

        </div>
    </div>
</template>
  
<script>
export default {
    name: 'ThankYouPage',
    data() {
        return {
            confettiCount: 100,
            confettiColors: ['#f87171', '#fbbf24', '#34d399', '#60a5fa', '#a78bfa', '#f472b6']
        };
    },
    methods: {
        getConfettiStyle(index) {
            const color = this.confettiColors[index % this.confettiColors.length];
            const left = Math.random() * 100;
            const delay = Math.random() * 3;
            const size = Math.random() * 8 + 4;
            const rotation = Math.random() * 360;
            const duration = Math.random() * 3 + 3;
            return {
                left: `${left}%`,
                backgroundColor: color,
                width: `${size}px`,
                height: `${size * 0.4}px`,
                transform: `rotate(${rotation}deg)`,
                animationDelay: `${delay}s`,
                animationDuration: `${duration}s`
            };
        },
    }
};
</script>
  
<style scoped>
.thank-you-page {
    position: relative;
    height: 100%;
    overflow: hidden;
}

/* Confetti animation */
.confetti {
    position: absolute;
    top: -10px;
    border-radius: 2px;
    opacity: 0.9;
    animation-name: fall;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}

@keyframes fall {
    0% {
        transform: translateY(0) rotate(0deg);
        opacity: 1;
    }

    100% {
        transform: translateY(100vh) rotate(720deg);
        opacity: 0;
    }
}
</style>
  